
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Icon from '~/components/common/icon/Icon.vue'

const styleClassesByType = {
  'rounded-square': 'rounded-sm text-14',
  rounded: 'rounded-50 text-gray-4 text-14',
  'no-fill': 'rounded-sm text-gray-1 font-semibold underline text-16',
  outline: ''
}

const styleClassesByColor = {
  green: 'text-gray-4',
  lightgreen: 'text-sec-1',
  orange: 'text-gray-4',
  red: 'text-gray-4',
  outline: 'text-gray-1',
  'no-fill': '',
  'rounded-square': '',
  rounded: ''
}

const buttonColors = {
  green: 'd-button_green',
  lightgreen: 'd-button_lightgreen',
  orange: 'd-button_orange',
  red: 'd-button_red',
  'no-fill': 'd-button_no-fill',
  outline: 'd-button_outline',
  'rounded-square': '',
  rounded: ''
}

const stylesByType = {
  'rounded-square': {
    padding: '10px 22px',
    minHeight: '38px'
  },
  rounded: {
    padding: '14px 25px',
    minHeight: '47px'
  },
  outline: {
    padding: '14px 44px'
  },
  'no-fill': {
    padding: '14px'
  }
}

type Color = 'green' | 'orange' | 'red' | 'outline' | 'lightgreen'
type Type = 'rounded-square' | 'rounded' | 'no-fill' | 'outline'

@Component({
  name: 'DashboardButton',
  components: {
    Icon
  }
})
export default class DashboardButton extends Vue {
  // @ts-ignore
  @Prop({ type: String, default: 'rounded-square', validator: value => value.match(/(rounded-square|rounded|no-fill)/) }) type!: Type
  // @ts-ignore
  @Prop({ type: String, default: 'green', validator: value => value.match(/(green|orange|red|outline|lightgreen)/) }) color!: Color
  @Prop({ type: Boolean, default: false }) isActive!: boolean
  @Prop({ type: Boolean, default: false }) isPending!: boolean
  @Prop({ type: Boolean, default: false }) disabled!: boolean

  mounted() {
    this.btnColor = this.color

    if (this.type.includes('outline') || this.type.includes('no-fill')) {
      this.btnColor = this.type
    }
  }

  clickHandler(ev) {
    if (this.isPending) { return }
    this.$emit('click', ev)
  }

  loaderProps = {
    'rounded-square': {
      color: 'white',
      size: '25px'
    },
    rounded: {
      color: 'white',
      size: '30px'
    },
    outline: {
      color: 'black',
      size: '30px'
    },
    'no-fill': {
      color: 'black',
      size: '25px'
    }
  }

  btnColor: Color | Type = 'green'

  @Watch('color')
  changeColor(val: Color) {
    this.btnColor = val
  }

  get buttonStyleClasses() {
    const borderSize = this.type.includes('no-fill')
      ? ''
      : !this.color.includes('outline')
          ? 'border-3'
          : this.type.includes('rounded-square')
            ? 'border'
            : 'border-2'

    const fontWeight = (this.color.includes('outline') && this.type.includes('rounded')) || this.type.includes('no-fill')
      ? 'font-semibold'
      : 'font-bold'

    let classes = `${buttonColors[this.btnColor]} ${styleClassesByColor[this.btnColor]} ${styleClassesByType[this.type]} ${borderSize} ${fontWeight}`

    if (this.isActive) {
      classes += 'active '
    }

    return classes
  }

  get buttonStyles() {
    return stylesByType[this.type]
  }

  get tag() {
    return this.$attrs.href ? 'a' : 'button'
  }
}
